<template>
<div @dblclick.stop="onDblClickName" style="cursor: pointer; width:100%; display: flex; align-items: center;">
    <span v-show="!editing">{{data.eventMessageFormatString}}</span>
    <el-input v-show="editing" ref="nameField" placeholder="Please input" @keyup.native.enter="$refs.nameField.blur()" v-model="data.eventMessageFormatString" @blur="editing = false" @change="handleChange"></el-input>
  </div>
</template>

<script>
export default {
  name: 'WEventFormatInputComponent',
  props: {
    data: {
      type: Object,
    },
  },
  data() {
    return {
      editing: false,
    };
  },
  methods: {
    onDblClickName() {
      this.editing = !this.editing;
      this.$nextTick(() => {
        this.$refs.nameField.focus();
      });
    },
    handleChange() {
      this.$emit('append-msg-format', this.data);
    },
  },
};
</script>

<style scoped>
.msg-div-class {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/EventAlarmSettings/EventSettings/components/EventFormatInputComponent.vue